import { cn } from "@newxsystems/shared";
import type { IDaylightRichTextProps } from "./DaylightRichText.props";

export const DaylightRichText = ({ className, content }: IDaylightRichTextProps) => (
  <div
    className={cn(
      "font-daylight-body text-base leading-[1.55] text-pretty text-foreground md:text-[17px] [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4 [&_blockquote]:border-l [&_blockquote]:border-weathered-steel [&_blockquote]:pl-6 [&_blockquote]:text-basalt [&_li]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_p+p]:mt-5 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-6",
      className,
    )}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

DaylightRichText.displayName = "Content::DaylightRichText";
